import { PatientChartInfo } from 'types';

export const isPatientEmpty = (patient?: Partial<PatientChartInfo>) => {
  if (!patient) {
    return true;
  }
  const { firstName, lastName, email } = patient;
  return !(firstName && lastName && email);
};

export const getFullNameFromPatientChart = (patientChart: PatientChartInfo) => {
  return patientChart.actualName || `${patientChart.firstName} ${patientChart.lastName}`;
};
